import { ConfirmationModal, Text } from '@shared/components';

interface SubmitExamCenterProctorRequestVerdictConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  variant?: 'Approved' | 'Rejected';
  isTerminal?: boolean;
}

function ApprovedText({ isTerminal }: Readonly<{ isTerminal?: boolean }>) {
  return (
    <Text>
      คุณกำลังจะ{` `}
      <Text variant='body1Semibold' component='span'>
        “อนุมัติคำขอ”
      </Text>
      {` `}รายการนี้ <br />
      {isTerminal ? (
        <>
          ผลอนุมัติจะถือเป็นที่สิ้นสุด และไม่สามารถเปลี่ยนแปลงได้
          <br />
          กรุณาตรวจสอบให้แน่ใจก่อนดำเนินการ
        </>
      ) : (
        'ผลอนุมัติจะถูกส่งต่อให้ผู้อนุมัติลำดับถัดไป และไม่สามารถเปลี่ยนแปลงได้ กรุณาตรวจสอบให้แน่ใจก่อนดำเนินการ'
      )}
    </Text>
  );
}

function RejectedText() {
  return (
    <Text>
      คุณกำลังจะ{` `}
      <Text variant='body1Semibold' component='span'>
        “ไม่อนุมัติคำขอ”
      </Text>
      {` `}รายการนี้ <br />
      ผลอนุมัติจะถูกส่งต่อให้ศูนย์ทดสอบเพื่อดำเนินการต่อ
    </Text>
  );
}

export default function SubmitExamCenterProctorRequestVerdictConfirmModal(
  props: Readonly<SubmitExamCenterProctorRequestVerdictConfirmModalProps>,
) {
  const { open: isOpen, onClose, onConfirm, variant, isTerminal } = props;

  return (
    <ConfirmationModal
      title='ยืนยันการอนุมัติคำขอ'
      open={isOpen}
      onClose={onClose}
      onAccept={onConfirm}
      onDiscard={onClose}
      discardText='ยกเลิก'
      acceptText='บันทึกและอนุมัติ'
      content={variant === 'Approved' ? <ApprovedText isTerminal={isTerminal} /> : <RejectedText />}
    />
  );
}
